export { default as FullCycleTable } from './component';
